var _g, _defs;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHavekit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 288,
    height: 192,
    viewBox: "0 0 288 192",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1468_642)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M235.608 191.836L222.162 65.5634C222.162 65.5634 222.668 31.3878 213.842 29.4855C179.438 22.1912 154.653 23.267 154.653 23.267L137.408 48.7249L119.848 22.998C119.848 22.998 78.436 24.3756 70.7519 31.9388C63.2451 39.3249 61.8736 73.1004 61.8736 73.1004L47.2207 191.829",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.608 191.836L222.162 65.5634C222.162 65.5634 222.668 31.3878 213.842 29.4855C179.438 22.1912 154.653 23.267 154.653 23.267L137.408 48.7249L119.848 22.998C119.848 22.998 78.436 24.3756 70.7519 31.9388C63.2451 39.3249 61.8736 73.1004 61.8736 73.1004L47.2207 191.829",
    stroke: "#0C0E1F",
    strokeWidth: 3,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.815 152.557L219.209 120.205C262.321 125.118 262.82 77.915 223.042 64.166L197.306 26.4482C332.935 44.7824 294.016 179.346 208.815 152.557Z",
    fill: "#0C0E1F",
    stroke: "#0C0F1E",
    strokeWidth: 3,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.0483 26.2515L61.7691 70.2009C30.8361 93.9073 38.0477 121.517 75.5492 123.911L70.8639 148.969C-0.582623 162.062 -45.8009 56.839 86.0483 26.2515Z",
    fill: "#0C0E1F",
    stroke: "#0C0F1E",
    strokeWidth: 3,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.309 138.447C123.137 134.262 103.753 141.032 93.9361 137.608C92.4203 136.355 92.4268 135.705 94.1198 134.643C98.1095 133.58 100.629 133.711 105.236 134.249C107.644 132.813 107.723 131.927 105.485 130.209C95.3271 126.017 88.1155 124.915 72.8065 124.961L70.582 143.544C108.937 146.667 127.507 142.259 125.309 138.447Z",
    fill: "white",
    stroke: "#0C0F1E",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.222 0.177246L146.306 22.9194L154.66 23.3065L136.759 48.9283L119.849 23.0309L127.526 22.4471L129.619 0.177246",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.222 0.177246L146.306 22.9194L154.66 23.3065L136.759 48.9283L119.849 23.0309L127.526 22.4471L129.619 0.177246",
    stroke: "#0C0E1F",
    strokeWidth: 3,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.424 146.889C179.024 148.11 175.691 148.116 171.983 146.889C168.276 145.663 165.598 143.702 165.999 142.481",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.424 146.889C179.024 148.11 175.691 148.116 171.983 146.889C168.276 145.663 165.598 143.702 165.999 142.481",
    stroke: "#0C0E1F",
    strokeWidth: 3,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.806 94.2354L165.999 142.494C165.598 143.715 167.462 148.182 171.17 149.395C174.877 150.609 179.044 148.083 179.425 146.889L194.95 98.6566",
    fill: "#2A214A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.806 94.2354L165.999 142.494C165.598 143.715 167.462 148.182 171.17 149.395C174.877 150.609 179.044 148.083 179.425 146.889L194.95 98.6566",
    stroke: "#0C0F1D",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.438 97.5544C196.939 99.0762 192.785 99.0828 188.159 97.5544C183.533 96.026 180.186 93.5793 180.685 92.0509L180.849 86.0029C181.348 84.4811 186.236 84.691 191.768 86.5212C197.3 88.3513 201.381 91.0341 200.883 92.556L197.438 97.5544Z",
    fill: "#F4B39E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.043 90.9361C187.956 91.3231 188.933 91.6904 189.964 92.0249C195.495 93.8353 200.384 94.0715 200.883 92.5431C201.381 91.0147 197.3 88.3188 191.768 86.5083C186.236 84.6979 181.348 84.4682 180.849 85.9901L180.685 92.038C180.186 93.5664 183.533 96.0263 188.159 97.5415C192.785 99.0568 196.939 99.0503 197.438 97.5415",
    stroke: "#0C0E1F",
    strokeWidth: 3,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.403 115.265C192.66 116.315 193.782 116.754 195.836 118.683C196.834 120.408 196.492 120.992 194.603 121.379C184.333 119.772 174.188 114.478 172.292 118.604C170.704 122.002 185.797 128.319 185.797 128.319C186.295 129.06 186.295 129.375 185.232 129.546C185.232 129.546 169.398 124.187 168.755 127.473C168.046 131.054 182.306 135.928 182.306 135.928C182.962 136.676 183.165 137.043 181.859 136.906C181.859 136.906 167.528 132.78 166.412 135.745C164.713 140.225 196.381 149.271 208.842 152.544L219.236 120.192C207.221 113.724 201.519 110.68 192.45 109.408",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.403 115.265C192.66 116.315 193.782 116.754 195.836 118.683C196.834 120.408 196.492 120.992 194.603 121.379C184.333 119.772 174.188 114.478 172.292 118.604C170.704 122.002 185.797 128.319 185.797 128.319C186.295 129.06 186.295 129.375 185.232 129.546C185.232 129.546 169.398 124.187 168.755 127.473C168.046 131.054 182.306 135.928 182.306 135.928C182.962 136.676 183.165 137.043 181.859 136.906C181.859 136.906 167.528 132.78 166.412 135.745C164.713 140.225 196.381 149.27 208.842 152.544L219.236 120.192C207.221 113.724 201.519 110.68 192.45 109.408",
    stroke: "#0C0E1F",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.582 143.531C83.1154 146.522 115.289 147.028 115.289 142.495C115.289 138.434 103.753 141.032 93.9361 137.608",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.582 143.531C83.1154 146.522 115.289 147.028 115.289 142.495C115.289 138.434 103.753 141.032 93.9361 137.608",
    stroke: "#0C0F1E",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.702 122.777C144.201 122.777 144.693 122.777 145.191 122.737V92.4711L136.038 84.98H105.853C105.853 89.9468 106.832 94.8649 108.734 99.4532C110.637 104.041 113.426 108.21 116.941 111.72C120.456 115.23 124.629 118.014 129.221 119.911C133.812 121.808 138.733 122.782 143.702 122.777Z",
    fill: "#F4B39E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.641 137.614H99.8936",
    stroke: "#0C0F1E",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.5879 123.458V92.4707H145.191V137.614H124.402",
    stroke: "#0C0F1E",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.849 101.681H136.516",
    stroke: "#0C0F1E",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.653 108.483H136.516",
    stroke: "#0C0F1E",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.653 115.285H136.516",
    stroke: "#0C0F1E",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.5879 92.4709L79.2562 84.9863H136.05L145.191 92.4709",
    stroke: "#0C0E1F",
    strokeWidth: 3,
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1468_642"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 287,
    height: 192,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHavekit);
export default __webpack_public_path__ + "static/media/havekit.17b3eab427dc86eb78062307d911cec9.svg";
export { ForwardRef as ReactComponent };